import { memo } from 'react';
import PropTypes from 'prop-types';
import Styles from './PillSelector.module.scss';
import classNames from 'classnames';

const PillSelector = memo(
  ({ textKey = 'label', items = [], containerProps, pillProps, selected = [], onSelect }) => {
    const handleSelect = (item, idx) => onSelect?.(item, idx);
    return (
      <div {...containerProps}>
        {items.map((v, idx) => (
          <button
            key={v.id}
            className={classNames(Styles.pill, selected.includes(idx) && Styles.selected)}
            onClick={() => handleSelect(v, idx)}
            {...pillProps}>
            {v[textKey] || v?.text || v?.name}
          </button>
        ))}
      </div>
    );
  }
);

PillSelector.propTypes = {
  textKey: PropTypes.string,
  items: PropTypes.array,
  selected: PropTypes.array,
  containerProps: PropTypes.object,
  pillProps: PropTypes.object,
  onSelect: PropTypes.func,
};

export default PillSelector;
